export default {
  USER_ALREADY_EXISTS: 'UserAlreadyExists',
  SOCIETY_ALREADY_EXISTS: 'SocietyAlreadyExists',
  GENERIC_ERROR: 'ErrorCreatingUser',
};

export const errorEvents = {
  BRANDFETCH_ERROR: 'Error - Demo - BrandFetch',
};
